import { cn } from "@/lib/utils";

interface GlassyImageProps {
  src?: string | null;
  alt: string;
  className?: string;
  imageClassName?: string;
  fetchPriority?: "high" | "low" | "auto";
}

export function GlassyImage({ src, alt, className, imageClassName, fetchPriority }: GlassyImageProps) {
  return (
    <div className={cn("relative rounded-2xl overflow-hidden", className)}>
      {src ? (
        <img 
          src={src} 
          alt={alt} 
          className={cn("w-full h-full object-cover object-center", imageClassName)}
          fetchPriority={fetchPriority}
        />
      ) : null}
      {/* Inward border overlay */}
      <div className="absolute inset-0 rounded-2xl border-[24px] border-white/30 pointer-events-none" />
    </div>
  );
}
